<div class="align-center grey-background">
  @if (dataLoading$ | async) {
    <ds-localized-spinner
      [dataLoading]="dataLoading$ | async"
      [loadingMessage]="'Looking for payment history...'"
    >
    </ds-localized-spinner>
  } @else {
    <div class="manage-autopay-container">
      <div
        class="header font-weight-semibold"
        dsContent
        [contentPath]="'billing.manageAutopay.autopayHeader'"
      ></div>
      <div
        class="header-info font-size-1"
        dsContent
        [contentPath]="'billing.manageAutopay.autopayHeaderInfo'"
      ></div>
      @if (autopayAccountsList.notEnrolledAccounts.length) {
        <div
          class="sub-header font-weight-semibold"
          dsContent
          [contentPath]="'billing.manageAutopay.autopaySubHeaderNotEnrolled'"
        ></div>
        @for (billAccount of autopayAccountsList.notEnrolledAccounts; track billAccount.riskDesc) {
          <div class="tile">
            <div>
              <div
                class="error-pill pill font-weight-bold"
                dsContent
                [contentPath]="'billing.manageAutopay.autopayErrorPill'"
              ></div>
              @for (risk of billAccount.riskDesc; track risk) {
                <div class="risk-desc">{{ risk }}</div>
              }
            </div>
            <div class="action-container">
              <div
                class="action-btn font-weight-semibold"
                (click)="setUpAutopay(billAccount.accountNumber)"
              >
                <span dsContent [contentPath]="'billing.manageAutopay.setUp'"></span>
                <img src="/assets/images/chevron-right-thick.svg" />
              </div>
            </div>
          </div>
        }
      }
      @if (autopayAccountsList.enrolledAccounts.length) {
        <div
          class="sub-header font-weight-semibold second-section"
          dsContent
          [contentPath]="'billing.manageAutopay.autopaySubHeaderEnrolled'"
        ></div>
        @for (billAccount of autopayAccountsList.enrolledAccounts; track billAccount.riskDesc) {
          <div class="tile">
            <div>
              <div
                class="success-pill pill font-weight-bold"
                dsContent
                [contentPath]="'billing.manageAutopay.autopaySuccessPill'"
              ></div>
              @for (risk of billAccount.riskDesc; track risk) {
                <div class="risk-desc">{{ risk }}</div>
              }
            </div>
            <div class="action-container">
              <div
                class="action-btn font-weight-semibold"
                (click)="editAutoPayClick(billAccount.accountNumber)"
              >
                <span dsContent [contentPath]="'billing.editAutopay'"></span>
                <img src="/assets/images/chevron-right-thick.svg" />
              </div>
            </div>
          </div>
        }
      }
    </div>
  }
</div>
